import React from 'react';
export function Footer() {
  return <footer className="bg-[#050505] text-gray-500 py-6 px-3 border-t border-white/10" data-id="element-78">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-79">
        <p className="text-xs md:text-sm font-bold mb-2 text-gray-400" data-id="element-80">
          Copyright 2026 - Todos los derechos reservados.
        </p>
        <p className="text-[10px] md:text-xs text-gray-600 max-w-xl leading-relaxed" data-id="element-81">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}